import React from "react";
import { CalendarDays, X } from "lucide-react";

/**
 * Filtro de período (data inicial / data final), client-side.
 * Props:
 *  - from, to: string "YYYY-MM-DD" | ""
 *  - onChange: (next: { from?, to? }) => void
 *  - testidPrefix: string (ex: "ops" → ops-date-from / ops-date-to / ops-date-clear)
 */
export default function DateRangeFilter({ from, to, onChange, testidPrefix = "date" }) {
  const set = (key) => (e) => onChange({ [key]: e.target.value });
  const clear = () => onChange({ from: "", to: "" });
  const active = Boolean(from || to);

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={`${testidPrefix}-range`}>
      <CalendarDays className="h-4 w-4 text-zinc-500" aria-hidden />
      <label className="flex items-center gap-1.5 text-[12px] text-zinc-500">
        De
        <input
          type="date"
          value={from || ""}
          onChange={set("from")}
          max={to || undefined}
          className="h-9 rounded-md border border-[var(--zemo-border)] bg-transparent px-2 text-sm text-zinc-800 dark:text-zinc-100 focus:outline-none focus:ring-2 focus:ring-[#0055FF]"
          data-testid={`${testidPrefix}-date-from`}
        />
      </label>
      <label className="flex items-center gap-1.5 text-[12px] text-zinc-500">
        Até
        <input
          type="date"
          value={to || ""}
          onChange={set("to")}
          min={from || undefined}
          className="h-9 rounded-md border border-[var(--zemo-border)] bg-transparent px-2 text-sm text-zinc-800 dark:text-zinc-100 focus:outline-none focus:ring-2 focus:ring-[#0055FF]"
          data-testid={`${testidPrefix}-date-to`}
        />
      </label>
      {active && (
        <button
          type="button"
          onClick={clear}
          className="inline-flex items-center gap-1 h-9 px-2 rounded-md text-[12px] text-zinc-500 hover:text-zinc-800 hover:bg-zinc-100"
          data-testid={`${testidPrefix}-date-clear`}
          title="Limpar período"
        >
          <X className="h-3.5 w-3.5" /> Limpar
        </button>
      )}
    </div>
  );
}

/** Compara `iso` (string ISO/Date) com o range [from, to] inclusivo. Datas vazias = sem limite. */
export function isInRange(iso, from, to) {
  if (!iso) return !from && !to;
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return !from && !to;
  if (from) {
    const f = new Date(`${from}T00:00:00`).getTime();
    if (t < f) return false;
  }
  if (to) {
    const e = new Date(`${to}T23:59:59.999`).getTime();
    if (t > e) return false;
  }
  return true;
}
